<h2 mat-dialog-title class="dialog-header">
  <div class="dialog-title-block">
    <span class="dialog-overline">{{ dialogModeTitle }}</span>
    <div class="dialog-title-row">
      <div>
        <div class="dialog-title">{{orderUuid || 'Nueva reserva'}}</div>
        <div class="dialog-subtitle">{{ dialogModeSubtitle }}</div>
      </div>
    </div>
  </div>

  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="form-container">
    <div class="top-grid" appGridColumns [colsLg]="2" [colsMd]="2" [colsSm]="1">
      <mat-card class="detail-card">
        <div class="card-heading">
          <div>
            <h3>Rango y categoria</h3>
            <p>Selecciona el periodo y anade los items a reservar.</p>
          </div>
          <mat-icon>date_range</mat-icon>
        </div>

        <div class="form-section">
          <div formGroupName="dateRange" class="datetime-range">
            <app-date-time-range-picker
              (formReady)="onFormReady($event)"
              (formUpdated)="onFormUpdated($event)"
              label="Rango de fechas">
            </app-date-time-range-picker>
          </div>
        </div>

        <div class="form-section row gap-sm center add-item-row">
          <mat-form-field appearance="outline">
            <mat-label>{{'reserve.manual.form.category'|traduccion}}</mat-label>
            <mat-select #categorySelected formControlName="selectedCategoryItem">
              <mat-option *ngFor="let cat of flatCategories" [value]="cat" [disabled]="cat.expandable">
                <span [style.padding-left.px]="cat.level * 16">{{cat.name}}</span>
              </mat-option>
            </mat-select>
            <app-form-error [control]="form.get('selectedCategoryItem')"></app-form-error>
          </mat-form-field>

          <button
            mat-flat-button
            color="primary"
            class="icon-action"
            type="button"
            [disabled]="!isValidateItemSelected"
            (click)="addItem(categorySelected?.value)">
            <mat-icon>add_circle</mat-icon>
            Anadir
          </button>
        </div>
      </mat-card>

      <mat-card class="detail-card accent-card">
        <div class="card-heading">
          <div>
            <h3>Condiciones y acceso</h3>
            <p>Aplica descuento, marca gratis si procede y define contrasenas.</p>
          </div>
          <mat-icon>lock</mat-icon>
        </div>

        <div class="form-section">
          <mat-form-field appearance="outline">
            <mat-label>{{'reserve.manual.form.discountCode'|traduccion}}</mat-label>
            <input matInput type="text" placeholder="Ej: CLDO4" formControlName="discountCode" [readonly]="form.get('isFree')?.value">
            <app-form-error [control]="form.get('discountCode')"></app-form-error>
          </mat-form-field>

          <div class="toggle-row">
            <mat-checkbox formControlName="isFree">{{'reserve.manual.form.free'|traduccion}}</mat-checkbox>
            <app-form-error [control]="form.get('isFree')"></app-form-error>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>{{'reserve.manual.form.customerId'|traduccion}}</mat-label>
            <input matInput type="number" formControlName="customerId">
            <app-form-error [control]="form.get('customerId')"></app-form-error>
          </mat-form-field>
        </div>

        <div class="row gap-sm center password-row">
          <mat-form-field *ngIf="isEnableProvisionalPassword" appearance="outline" class="small">
            <mat-label>{{'reserve.manual.form.provisionalPassword'|traduccion}}</mat-label>
            <input matInput formControlName="provisionalPassword" minlength="4" maxlength="4" />
            <app-form-error [control]="form.get('provisionalPassword')"></app-form-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="small">
            <mat-label>{{'reserve.manual.form.checkoutPassword'|traduccion}}</mat-label>
            <input matInput formControlName="checkoutPassword" minlength="4" maxlength="4" />
            <app-form-error [control]="form.get('checkoutPassword')"></app-form-error>
          </mat-form-field>
        </div>
      </mat-card>
    </div>
  </form>

  <mat-card class="summary-card">
    <div class="card-heading">
      <div>
        <h3>{{'reserve.manual.item'|traduccion}}</h3>
        <p>Resumen de periodos, items y precios calculados.</p>
      </div>
      <div class="summary-dates">
        <span><strong>Inicio:</strong> {{infoCart.startDate | date: appService.FORMAT_DATETIME}}</span>
        <span><strong>Fin:</strong> {{infoCart.endDate | date: appService.FORMAT_DATETIME}}</span>
      </div>
    </div>

    <ng-container [ngSwitch]="state">
      <div *ngSwitchCase="'idle'" class="placeholder">
        <mat-icon>search</mat-icon>
        <div [innerHTML]="'reserve.manual.table.idle'|traduccion"></div>
      </div>

      <div *ngSwitchCase="'loading'" class="placeholder">
        <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
        <div>{{'reserve.manual.table.loading'|traduccion}}</div>
      </div>

      <div *ngSwitchCase="'error'" class="placeholder error">
        <mat-icon>error_outline</mat-icon>
        <div>{{'reserve.manual.table.error'|traduccion}}</div>
      </div>

      <div *ngSwitchCase="'loaded'" class="table-shell">
        <app-data-table
          class="cart-items-desktop-view"
          preset="modal"
          [dataSource]="infoCart.items"
          [displayedColumns]="displayedColumns"
          tableClass="full-width-table"
          emptyIcon="inbox"
          [emptyMessage]="'reserve.manual.table.nodata'|traduccion">
          <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.manual.table.ref'|traduccion}}</th>
            <td mat-cell *matCellDef="let item">{{ item.type }}-{{ item.size }}</td>
          </ng-container>

          <ng-container matColumnDef="nLocker">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.manual.table.nLocker'|traduccion}}</th>
            <td mat-cell *matCellDef="let item">{{ item.nLocker }}</td>
          </ng-container>

          <ng-container matColumnDef="discount">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.manual.table.discount'|traduccion}}</th>
            <td mat-cell *matCellDef="let item">{{ item.descriptionDiscount || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="precio">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.manual.table.priceWithoutDiscount'|traduccion}}</th>
            <td mat-cell *matCellDef="let item">{{ item.totalPriceWithoutDiscount|currency }}</td>
          </ng-container>

          <ng-container matColumnDef="precioFinal">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.manual.table.priceFinal'|traduccion}}</th>
            <td mat-cell *matCellDef="let item"><strong>{{ item.totalPrice|currency }}</strong></td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="text-right">
              <button mat-stroked-button color="warn" class="cancel-btn" (click)="removeItem(row); $event.stopPropagation()">
                {{'reserve.manual.table.delete'|traduccion}}
              </button>
            </td>
          </ng-container>
        </app-data-table>

        <div class="cart-items-mobile-view" *ngIf="infoCart.items?.length; else noCartItemsMobile">
          <article class="cart-item-mobile-card" *ngFor="let item of infoCart.items">
            <div class="cart-item-mobile-row">
              <span class="cart-item-mobile-label">{{'reserve.manual.table.ref'|traduccion}}</span>
              <strong>{{ item.type }}-{{ item.size }}</strong>
            </div>
            <div class="cart-item-mobile-row">
              <span class="cart-item-mobile-label">{{'reserve.manual.table.nLocker'|traduccion}}</span>
              <strong>{{ item.nLocker }}</strong>
            </div>
            <div class="cart-item-mobile-row">
              <span class="cart-item-mobile-label">{{'reserve.manual.table.discount'|traduccion}}</span>
              <strong>{{ item.descriptionDiscount || '-' }}</strong>
            </div>
            <div class="cart-item-mobile-row">
              <span class="cart-item-mobile-label">{{'reserve.manual.table.priceWithoutDiscount'|traduccion}}</span>
              <strong>{{ item.totalPriceWithoutDiscount|currency }}</strong>
            </div>
            <div class="cart-item-mobile-row cart-item-mobile-row--final">
              <span class="cart-item-mobile-label">{{'reserve.manual.table.priceFinal'|traduccion}}</span>
              <strong>{{ item.totalPrice|currency }}</strong>
            </div>
            <button mat-stroked-button color="warn" class="cancel-btn cart-item-mobile-action" (click)="removeItem(item)">
              {{'reserve.manual.table.delete'|traduccion}}
            </button>
          </article>
        </div>

        <ng-template #noCartItemsMobile>
          <div class="cart-items-mobile-empty">
            {{'reserve.manual.table.nodata'|traduccion}}
          </div>
        </ng-template>

        <div class="totals-summary" *ngIf="infoCart.items?.length">
          <div class="totals-summary__row">
            <span>{{'reserve.manual.table.priceWithoutDiscount'|traduccion}}</span>
            <strong>{{ infoCart?.totalWithoutDiscount | currency }}</strong>
          </div>
          <div class="totals-summary__row totals-summary__row--final">
            <span>{{'reserve.manual.table.priceFinal'|traduccion}}</span>
            <strong>{{ infoCart.total | currency }}</strong>
          </div>
        </div>
      </div>
    </ng-container>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer" align="end">
  <button mat-stroked-button (click)="showCart()">
    <mat-icon>refresh</mat-icon>
    {{'reserve.action.updateCart'|traduccion}}
  </button>
  <button mat-flat-button color="primary" (click)="createReservation()" [disabled]="!isValidateForm">
    <mat-icon>bolt</mat-icon>
    {{'reserve.action.generateReserve'|traduccion}}
  </button>
</mat-dialog-actions>
